// City-specific data with historical landmarks and local destinations for SEO
export const CITY_DATA = {
  'meriden-ct': {
    name: 'Meriden',
    state: 'CT',
    zip: '06450',
    landmarks: ['Hubbard Park', 'Castle Craig', 'Giuffrida Park', 'Solomon Goffe House', 'Downtown Meriden Historic District'],
    destinations: ['Meriden Green', 'Linear Trail', 'Black Pond Wildlife Management Area', 'Meriden Square Mall'],
    searchTerms: ['near Hubbard Park', 'near Castle Craig', 'downtown Meriden', 'West Main Street Meriden', 'East Main Street'],
    history: 'historic Silver City known for silverware manufacturing since 1808',
    population: 'over 60,000 residents',
    neighborhoods: ['Broad Street', 'West Main Street', 'East Main Street', 'South Meriden', 'Tracy']
  },
  'wallingford-ct': {
    name: 'Wallingford',
    state: 'CT',
    zip: '06492',
    landmarks: ['Community Lake', 'Choate Rosemary Hall', 'Simpson Court Theatre', 'Wallingford Center Historic District'],
    destinations: ['Community Lake Beach', 'Tyler Mill Preserve', 'Wallingford Center', 'Route 5 shopping district'],
    searchTerms: ['near Community Lake', 'Center Street Wallingford', 'North Main Street', 'Yalesville'],
    history: 'historic town established in 1670 with rich colonial heritage',
    population: 'approximately 45,000 residents',
    neighborhoods: ['Wallingford Center', 'Yalesville', 'North Farms', 'South Main Street']
  },
  'southington-ct': {
    name: 'Southington',
    state: 'CT',
    zip: '06489',
    landmarks: ['Mount Southington Ski Area', 'Crescent Lake', 'Apple Harvest Festival grounds', 'Plantsville Historic District'],
    destinations: ['Crescent Lake', 'Mount Southington', 'Recreation Park', 'Main Street Southington'],
    searchTerms: ['near Mount Southington', 'Plantsville', 'Marion', 'Milldale'],
    history: 'agricultural community known for the annual Apple Harvest Festival since 1969',
    population: 'over 43,000 residents',
    neighborhoods: ['Plantsville', 'Marion', 'Milldale', 'South End']
  },
  'cheshire-ct': {
    name: 'Cheshire',
    state: 'CT',
    zip: '06410',
    landmarks: ['Bartlem Park', 'Lock 12 Historical Park', 'Farmington Canal Trail', 'Cheshire Academy'],
    destinations: ['Mixville Park', 'Bartlem Park pool', 'Cheshire Center', 'Route 10 corridor'],
    searchTerms: ['near Bartlem Park', 'Cheshire Center', 'West Main Street Cheshire', 'South Main Street'],
    history: 'bedroom community established in 1780 known for quality of life',
    population: 'approximately 29,000 residents',
    neighborhoods: ['Cheshire Center', 'West Cheshire', 'South Cheshire', 'Mixville']
  },
  'hamden-ct': {
    name: 'Hamden',
    state: 'CT',
    zip: '06514',
    landmarks: ['Sleeping Giant State Park', 'Quinnipiac University', 'Eli Whitney Museum', 'Brooksvale Park'],
    destinations: ['Sleeping Giant hiking trails', 'Whitneyville', 'Hamden Plaza', 'Dixwell Avenue corridor'],
    searchTerms: ['near Sleeping Giant', 'near Quinnipiac University', 'Whitneyville', 'Dixwell Avenue'],
    history: 'diverse community established in 1786 with industrial heritage',
    population: 'over 61,000 residents',
    neighborhoods: ['Whitneyville', 'Spring Glen', 'Highwood', 'Mount Carmel']
  },
  'colchester-ct': {
    name: 'Colchester',
    state: 'CT',
    zip: '06415',
    landmarks: ['Salmon River State Forest', 'Day Pond State Park', 'Colchester Historic District', 'Hayward Brook'],
    destinations: ['Salmon River', 'Day Pond', 'Colchester Town Green', 'Route 16 corridor'],
    searchTerms: ['near Salmon River', 'Westchester', 'North Westchester', 'Route 85 Colchester'],
    history: 'rural community established in 1698 with agricultural heritage',
    population: 'approximately 16,000 residents',
    neighborhoods: ['Westchester', 'North Westchester', 'Colchester Center']
  },
  'middlefield-ct': {
    name: 'Middlefield',
    state: 'CT',
    zip: '06455',
    landmarks: ['Lyman Orchards', 'Powder Ridge Mountain Park', 'Pameacha Pond', 'Middlefield Center'],
    destinations: ['Lyman Orchards Golf Course', 'Apple Barrel Market', 'Wadsworth Falls State Park nearby'],
    searchTerms: ['near Lyman Orchards', 'Powder Ridge', 'Route 147 Middlefield'],
    history: 'agricultural town known for Lyman Orchards apple picking since 1741',
    population: 'approximately 4,500 residents',
    neighborhoods: ['Middlefield Center', 'Rockfall']
  },
  'east-haddam-ct': {
    name: 'East Haddam',
    state: 'CT',
    zip: '06423',
    landmarks: ['Goodspeed Opera House', 'Gillette Castle State Park', "Devil's Hopyard State Park", 'Nathan Hale Schoolhouse'],
    destinations: ['Connecticut River waterfront', 'Moodus', 'Goodspeed Opera performances'],
    searchTerms: ['near Goodspeed Opera House', 'near Gillette Castle', 'Moodus', 'Connecticut River East Haddam'],
    history: 'scenic Connecticut River town established in 1734 known for theater',
    population: 'approximately 9,000 residents',
    neighborhoods: ['Moodus', 'East Haddam village', 'Millington']
  },
  'old-saybrook-ct': {
    name: 'Old Saybrook',
    state: 'CT',
    zip: '06475',
    landmarks: ["Harvey's Beach", 'Katharine Hepburn Museum', 'Fort Saybrook Monument Park', 'Old Saybrook Point'],
    destinations: ['Main Street Old Saybrook', 'Long Island Sound beaches', 'Connecticut River mouth', 'Saybrook Point Inn'],
    searchTerms: ["near Harvey's Beach", 'Old Saybrook Point', 'Main Street Old Saybrook', 'shoreline Old Saybrook'],
    history: 'historic shoreline town founded in 1635 at the Connecticut River mouth',
    population: 'over 10,000 residents',
    neighborhoods: ['Old Saybrook Center', 'Chalker Beach', 'Fenwick']
  },
  'westbrook-ct': {
    name: 'Westbrook',
    state: 'CT',
    zip: '06498',
    landmarks: ['Westbrook Town Beach', 'Chapman Beach', 'Menunketesuck Island', 'Westbrook Outlets'],
    destinations: ['Tanger Outlets', 'Long Island Sound beaches', 'Boston Post Road corridor'],
    searchTerms: ['near Westbrook outlets', 'Westbrook beaches', 'Route 1 Westbrook'],
    history: 'shoreline community established in 1840 known for summer tourism',
    population: 'approximately 6,900 residents',
    neighborhoods: ['Westbrook Center', 'Grove Beach Point', 'Pilots Point']
  },
  'madison-ct': {
    name: 'Madison',
    state: 'CT',
    zip: '06443',
    landmarks: ['Hammonasset Beach State Park', 'Madison Beach Hotel', 'Deacon John Grave House', 'Madison Town Green'],
    destinations: ['Hammonasset Beach', 'Madison Village', 'Boston Post Road shopping', 'Surf Club'],
    searchTerms: ['near Hammonasset Beach', 'Madison Town Center', 'Route 1 Madison', 'Madison beaches'],
    history: 'upscale shoreline community established in 1826 with pristine beaches',
    population: 'over 18,000 residents',
    neighborhoods: ['Madison Center', 'Madison Beach', 'North Madison']
  },
  'guilford-ct': {
    name: 'Guilford',
    state: 'CT',
    zip: '06437',
    landmarks: ['Guilford Green', 'Henry Whitfield State Museum', 'Jacobs Beach', "Bishop's Orchards"],
    destinations: ['Guilford Town Green', 'Whitfield Street shopping', 'Long Island Sound beaches'],
    searchTerms: ['near Guilford Green', 'Whitfield Street Guilford', 'Guilford beaches', 'Route 1 Guilford'],
    history: 'historic colonial town founded in 1639 with well-preserved town green',
    population: 'approximately 22,000 residents',
    neighborhoods: ['Guilford Center', 'Sachem Head', 'North Guilford']
  },
  'branford-ct': {
    name: 'Branford',
    state: 'CT',
    zip: '06405',
    landmarks: ['Thimble Islands', 'Branford Point', 'Stony Creek', 'Harrison House Museum'],
    destinations: ['Thimble Islands cruises', 'Stony Creek village', 'Branford Center', 'Short Beach'],
    searchTerms: ['near Thimble Islands', 'Stony Creek', 'Branford Center', 'Short Beach Branford'],
    history: 'picturesque shoreline town established in 1644 known for Thimble Islands',
    population: 'over 28,000 residents',
    neighborhoods: ['Branford Center', 'Stony Creek', 'Pine Orchard', 'Short Beach']
  },
  'deep-river-ct': {
    name: 'Deep River',
    state: 'CT',
    zip: '06417',
    landmarks: ['Main Street Historic District', 'Stone House', 'Deep River Ancient Muster site', 'Connecticut River'],
    destinations: ['Main Street Deep River', 'Connecticut River waterfront', 'Devitt Field'],
    searchTerms: ['Main Street Deep River', 'near Connecticut River', 'Winthrop'],
    history: 'charming river town established in 1635 known for Ancient Muster fife and drum',
    population: 'approximately 4,600 residents',
    neighborhoods: ['Deep River Center', 'Winthrop']
  },
  'middletown-ct': {
    name: 'Middletown',
    state: 'CT',
    zip: '06457',
    landmarks: ['Wesleyan University', 'Harbor Park', 'Main Street Arts District', 'Wadsworth Mansion'],
    destinations: ['Downtown Middletown', 'Connecticut River waterfront', 'Main Street restaurants', 'Wesleyan campus'],
    searchTerms: ['near Wesleyan University', 'Downtown Middletown', 'Main Street Middletown', 'Harbor Park'],
    history: 'vibrant city established in 1650 known for arts and Wesleyan University',
    population: 'over 47,000 residents',
    neighborhoods: ['Downtown', 'South End', 'Westfield', 'Westlake']
  },
  'clinton-ct': {
    name: 'Clinton',
    state: 'CT',
    zip: '06413',
    landmarks: ['Clinton Beach', 'Cedar Island Marina', 'Chamard Vineyards', 'Clinton Crossing outlets'],
    destinations: ['Clinton Town Beach', 'Chamard Vineyards winery', 'Clinton Crossing Premium Outlets'],
    searchTerms: ['Clinton Beach', 'near Clinton outlets', 'Route 1 Clinton', 'Clinton marina'],
    history: 'coastal community established in 1663 known for beaches and marinas',
    population: 'approximately 13,000 residents',
    neighborhoods: ['Clinton Center', 'Clinton Beach', 'Grove Beach']
  },
  'chester-ct': {
    name: 'Chester',
    state: 'CT',
    zip: '06412',
    landmarks: ['Chester-Hadlyme Ferry', 'Chester Village shops', 'Cockaponset State Forest', 'Connecticut River'],
    destinations: ['Chester Village shopping', 'Connecticut River ferry', 'Main Street Chester'],
    searchTerms: ['Chester Village', 'near Chester ferry', 'Main Street Chester', 'Route 9 Chester'],
    history: 'picturesque river village established in 1836 known for boutique shopping',
    population: 'approximately 3,800 residents',
    neighborhoods: ['Chester Village', 'Chester Center']
  }
};

export const getLocalizedContent = (cityId, serviceType) => {
  const city = CITY_DATA[cityId];
  if (!city) return null;

  return {
    heroTitle: `${serviceType} ${city.name} CT | Professional ${serviceType} near ${city.landmarks[0]}`,
    introText: `Expert ${serviceType} contractor serving ${city.name}, Connecticut. Our team specializes in ${serviceType.toLowerCase()} for homeowners near ${city.landmarks.slice(0, 3).join(', ')}, and throughout ${city.name}. As a ${city.history}, ${city.name} homeowners trust Visser Construction for quality craftsmanship.`,
    localSection: {
      title: `Why ${city.name} Homeowners Choose Our ${serviceType} Services`,
      content: `${city.name} is a ${city.history} with ${city.population}. Our ${serviceType.toLowerCase()} services are trusted by homeowners throughout ${city.neighborhoods.join(', ')}, and near popular destinations like ${city.destinations.slice(0, 3).join(', ')}.`,
      landmarks: city.landmarks,
      searchTerms: city.searchTerms
    },
    seoKeywords: city.searchTerms.map(term => `${serviceType} ${term}`).join(', ')
  };
};